import { render, staticRenderFns } from "./stardisplay.vue?vue&type=template&id=c558595c&"
import script from "./stardisplay.vue?vue&type=script&lang=js&"
export * from "./stardisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c558595c')) {
      api.createRecord('c558595c', component.options)
    } else {
      api.reload('c558595c', component.options)
    }
    module.hot.accept("./stardisplay.vue?vue&type=template&id=c558595c&", function () {
      api.rerender('c558595c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25VvQ4XLo07p7/JS/stardisplay.vue"
export default component.exports